import React, { PropTypes } from 'react';
import './styles.scss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ButtonSpinner from '../ButtonSpinner';

class SetterModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    };
    this._confirm = this._confirm.bind(this);
    this._cancel = this._cancel.bind(this);
    this._destroy = this._destroy.bind(this);
  }

  _confirm() {
    this.props.confirm();
  }

  _cancel() {
    this.props.cancel();
  }

  _destroy() {
    this.props.destroy();
  }

  _renderModal() {
    let overlayClassName  = "SetterModal-overlay ",
        modalClassName    = "SetterModal-content ",
        headerClassName   = "SetterModal-header ",
        footerClassName   = "SetterModal-footer ";


    if (this.props.overlayClassName)        overlayClassName  += this.props.overlayClassName;
    if (this.props.modalClassName)          modalClassName    += this.props.modalClassName;
    if (this.props.centerHeaderTitle)       headerClassName   += "SetterModal-header-center ";
    if (this.props.centerFooterButtons)     footerClassName   += "SetterModal-footer-center ";
    if (this.props.fullWidthFooterButtons)  footerClassName   += "SetterModal-footer-fullwidth ";

    return (
      <div className="SetterModal-cage">
        <div className={overlayClassName}>

          <div className={modalClassName}>

          {this.props.hideHeader ||
            <div className={headerClassName}>
              <div className="SetterModal-header-title">
                <h4>{this.props.headerTitleText}</h4>
              </div>
              <button type="button" className="SetterModal-header-close" onClick={this.props.cancel}>
                <span aria-hidden="true">&times;</span>
                <span className="sr-only">Cancel</span>
              </button>
            </div>
          }

            <div className="SetterModal-body">
              {this.props.children}
            </div>

            <div className={footerClassName}>
              {this.props.leftFooter &&
                <div className="SetterModal-footer-left">
                  {this.props.leftFooter}
                </div>
              }
              <div className="SetterModal-footer-right">
                {this.props.cancel && this.props.cancelButtonText &&
                  <button
                    className="SetterModal-button-cancel btn btn-default"
                    onClick={this._cancel}
                  >
                    {this.props.cancelButtonText}
                  </button>
                }
                {this.props.destroy && this.props.destroyButtonText &&
                  <button
                    className="SetterModal-button-destroy btn btn-danger"
                    onClick={this._destroy}
                  >
                    {this.props.destroyButtonText}
                  </button>
                }
                {this.props.confirm && this.props.confirmButtonText &&
                  <button
                    className="SetterModal-button-confirm btn btn-success"
                    onClick={this._confirm}
                  >
                    {this.props.confirmButtonText}
                    {this.props.isLoading &&
                      <ButtonSpinner />
                    }
                  </button>
                }
              </div>
            </div>

          </div>

        </div>
      </div>
    );
  }

  render () {
    let dialog;

    if (this.props.isOpen) dialog = this._renderModal();


    return (
      <div className="SetterModal">
        <ReactCSSTransitionGroup transitionName="SetterModal-transition" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeave={false}>
          {dialog}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

SetterModal.propTypes = {
  isOpen                  : PropTypes.bool.isRequired,
  cancel                  : PropTypes.func,
  confirm                 : PropTypes.func,
  destroy                 : PropTypes.func,
  leftFooter              : PropTypes.element,
  confirmButtonText       : PropTypes.string,
  destroyButtonText       : PropTypes.string,
  cancelButtonText        : PropTypes.string,
  headerTitleText         : PropTypes.string,
  centerHeaderTitle       : PropTypes.bool,
  centerFooterButtons     : PropTypes.bool,
  fullWidthFooterButtons  : PropTypes.bool,
  hideHeader              : PropTypes.bool,
};

SetterModal.defaultProps = {
  centerHeaderTitle: false,
  centerFooterButtons: false,
  fullWidthFooterButtons: false,
  hideHeader: false,
};


export default SetterModal;



/** WEBPACK FOOTER **
 ** ../components/SetterModal/index.js
 **/